import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Cart from './Cart';
import Breadcrumbs from '../Category/Breadcrumbs';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { translate } from '../../utils/locale';
import s from './Selection.scss';

const Selection = ({ checkout, setup }) => {
	const hasItems = checkout.selection.items && checkout.selection.items.length > 0;

	return (
		<main role="main">
			<Breadcrumbs />
			{
				hasItems > 0 ? (
					<div className={s.selection}>
						<div className={s.selection_cart}>
							<h2 className={s.selection_title}>{ translate(setup, 'checkoutCart') }</h2>
							<ErrorBoundary message="Product data missing" debugData={checkout.selection}>
								<Cart position="selection" />
							</ErrorBoundary>
						</div>
					</div>
				) : (
					<div className={s.selection}>
						<h1 className={s.selection_title}>{ translate(setup, 'checkoutNoItems') }</h1>
					</div>
				)
			}
		</main>
	);
};


const mapState = ({ checkout, environment }) => {
	const { setup, header } = environment;
	return { checkout, setup, header };
};

export default hot(module)(connect(mapState)(Selection));
